module.exports = __webpack_public_path__ + "static/img/34.fec1b92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/34.jpg
// module id = C1Ci
// module chunks = 0